import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { ICommitmentData } from './models/apiCommitmentData'
import { IFetchCommitmentDataParameters } from './models/fetchCommitmentDataParameters'

export const fetchCommitmentData = async ({
  ownerId,
  partnerId,
  fYear,
  programType,
}: IFetchCommitmentDataParameters): Promise<ICommitmentData[]> => {
  const url = proxy('/webservice/621/sp/v3/spJBPCommitmentData/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': programType,
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response['Rows']) {
    return response['Rows']
  }
  return []
}
